module.exports = __webpack_public_path__ + "img/icon-shipping-combined.8267da3e.svg";